import { useCallback } from 'react';
import axios from 'axios';
import { webframeApi } from 'api/webframeApi';
import { useEnvironment, useHttp } from '@publicisgroupe/p-os-components';
import { SharepointEntities } from 'utils/enums';
import { CookieDeclarationDto, SharepointCookieDeclarationDto } from '../types';

const fetchFromWebframeApi = async (http: any) => {
  const response = await webframeApi(http)?.getCookieDeclarationConfig();

  return response?.data?.data;
};

const fetchFromSharePointApi = async (env: any) => {
  const response = await axios.get<{ value: any[] }>(
    `${env.settings.apiBaseURL}/mock/list?entity=${SharepointEntities.CookieDeclaration}`,
    {
      headers: {
        'Ocp-Apim-Subscription-Key': env.settings.ocpApimKey,
      },
    }
  );

  return response?.data?.value;
};

const transformCookieDeclarationSharepointResponse = (
  cookieData: SharepointCookieDeclarationDto | undefined
): CookieDeclarationDto | undefined => {
  if (!cookieData) return;

  return {
    title: cookieData.Title,
    description: cookieData.Description,
    isMandatory: cookieData.IsMandatory,
    isScript: cookieData.IsScript,
    maxAgeInDays: cookieData.MaxAgeInDays,
    name: cookieData.Name,
    value: cookieData.Value,
  };
};

export const useCookieDeclarationData = () => {
  const http = useHttp();
  const env = useEnvironment();

  return useCallback(
    async (useConfigModule: boolean) => {
      if (useConfigModule) {
        const responseCookieData = await fetchFromWebframeApi(http);

        if (!responseCookieData || responseCookieData.length === 0) return;

        return responseCookieData;
      } else {
        const responseCookieData = await fetchFromSharePointApi(env);

        if (!responseCookieData || responseCookieData.length === 0) return;

        const cookieBannerDtoResponse: CookieDeclarationDto[] = [];
        responseCookieData.map((cookieDeclaration) => {
          const transformedCookieDeclaration =
            transformCookieDeclarationSharepointResponse(cookieDeclaration);

          if (transformedCookieDeclaration)
            cookieBannerDtoResponse.push(transformedCookieDeclaration);
        });

        return cookieBannerDtoResponse;
      }
    },
    [http, env]
  );
};
